import RolePermissionService from '@/services/role_permission';

export default {
	namespaced: true,
	state: {
		rolesData: {
			tes: 'tes'
		}
	},

	getters: {
    async getRoles() {
			try {
        let response = await RolePermissionService.getRoles();
        
				return response.data.attributes;
				
			} catch (e) {
				console.log(e);
			}
    },
    async getPermissions(){
      try {
        let response = await RolePermissionService.getPermissions();
				return response.data.attributes;
				
			} catch (e) {
				console.log(e);
			}
    }
  },

	actions: {
    async addPermissions({ commit, state, getters, dispatch }, payload){
      try{
        let response = await RolePermissionService.addPermissions(payload);
        return response.data.attributes;
      }catch(e){
        console.log(e)
      }
    },
    async deletePermissions({ commit, state, getters, dispatch }, payload){
      try{
        await RolePermissionService.deletePermissions(payload);
        return "SUCCESS";
      }catch(e){
        console.log(e)
      }
    },
    async setPermissionToRole({ commit, state, getters, dispatch },payload){
      try{
        let response = await RolePermissionService.setPermissionToRole(payload.roleId,payload);
        
        return response.data;
      }catch(e){
        console.log(e)
      }
    }
	},

	mutations: {
		SET_ROLES_DATA(state, payload) {
			state.rolesData = payload;
		}
	}
};
